const table = {
    showingRange: '{{total}}件中 {{from}}〜{{to}}件',
    rowsPerPage: '1ページあたりの表示件数',
    previousPage: '前のページ',
    nextPage: '次のページ',
    goToPage: '{{page}}ページ目へ',
  };

export default table;
